var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skip-trace"},[_c('react-wrapper',{attrs:{"component":_vm.CreateSkipTracePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }